
export const ERR_MSG = {
    CHAIN_NOT_MATCH:{
        NO:-1001,
        MSG:"the chain id is not correct"
    }
}